import gql from 'graphql-tag';

const CREATE_EMERGENCY_CONTACT_LIST = gql`
  mutation CreateEmergencyContactList($data: CreateEmergencyContactListInput!) {
    createEmergencyContactList(data: $data) {
      id
      name
      workspaceId
    }
  }
`;

const UPDATE_EMERGENCY_CONTACT_LIST = gql`
  mutation UpdateEmergencyContactListById(
    $id: ID!
    $data: UpdateEmergencyContactListInput
  ) {
    updateEmergencyContactListById(id: $id, data: $data) {
      id
      name
    }
  }
`;

const DELETE_EMERGENCY_CONTACT_LIST_BY_ID = gql`
  mutation DeleteEmergencyContactListById($id: ID!) {
    deleteEmergencyContactListById(id: $id) {
      id
      name
    }
  }
`;

export default {
  CREATE_EMERGENCY_CONTACT_LIST,
  DELETE_EMERGENCY_CONTACT_LIST_BY_ID,
  UPDATE_EMERGENCY_CONTACT_LIST,
};
